/**
 * Which messages arrived while the thread was open, and so spring in (FAME-882).
 * What was on screen when it opened, and history loaded after, stays still.
 */

/** Slack for a server clock behind ours, so a live message still counts. */
const CLOCK_SKEW_MS = 60 * 1000

export type ThreadOpening = {
  /** Ids on screen when the thread opened. */
  ids: Set<string>
  /** Unix ms. */
  at: number
}

export function openThread(
  ids: string[],
  at: number = Date.now()
): ThreadOpening {
  return { ids: new Set(ids), at }
}

export function isArrival(
  message: { id: string; timestamp: number },
  opening: ThreadOpening
): boolean {
  return (
    !opening.ids.has(message.id) &&
    message.timestamp > opening.at - CLOCK_SKEW_MS
  )
}
